<script lang="ts" setup>
import { FormConfig } from "./types";

const props = defineProps<{
  config: FormConfig;
  modelValue: any;
  isVisible: boolean;
  loading: boolean;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: any): void;
  (e: "update:isVisible", value: boolean): void;
  (e: "submit"): void;
}>();

const value = computed({
  get: () => props.modelValue,
  set: (value: any) => emit("update:modelValue", value),
});
const dialogIsVisible = computed({
  get: () => props.isVisible,
  set: (value: boolean) => emit("update:isVisible", value),
});
</script>

<template>
  <VDialog
    :width="$vuetify.display.smAndDown ? 'auto' : 600"
    :model-value="dialogIsVisible"
    persistent
  >
    <!-- Dialog close btn -->
    <DialogCloseBtn @click="dialogIsVisible = false" />

    <VCard class="pa-2 pa-sm-10" :loading="loading">
      <FormTab :config="props.config" v-model="value" :loading="loading" />

      <!-- Dialog actions -->
      <VRow class="mt-5">
        <VCol>
          <VBtn
            color="primary"
            :loading="loading"
            class="mr-3"
            @click="emit('submit')"
            >{{ $t("Save") }}</VBtn
          >
          <VBtn
            color="danger"
            v-if="!loading"
            @click="dialogIsVisible = false"
            >{{ $t("Cancel") }}</VBtn
          >
        </VCol>
      </VRow>
    </VCard>
  </VDialog>
</template>
